import { render, staticRenderFns } from "./VisitorsView.vue?vue&type=template&id=bbbfd438&"
import script from "./VisitorsView.vue?vue&type=script&lang=js&"
export * from "./VisitorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbbfd438')) {
      api.createRecord('bbbfd438', component.options)
    } else {
      api.reload('bbbfd438', component.options)
    }
    module.hot.accept("./VisitorsView.vue?vue&type=template&id=bbbfd438&", function () {
      api.rerender('bbbfd438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/stats/metrics/VisitorsView.vue"
export default component.exports